// extracted by mini-css-extract-plugin
export default {"root":"NCME48tX","variant__rounded":"dm7FTf5o","icon":"y37W3Jgv"};